import { render, staticRenderFns } from "./helpList.vue?vue&type=template&id=fbc762c0&"
import script from "./helpList.vue?vue&type=script&lang=js&"
export * from "./helpList.vue?vue&type=script&lang=js&"
import style0 from "./helpList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports